import { render, staticRenderFns } from "./Step3-shade.vue?vue&type=template&id=fbc36c16&scoped=true&"
import script from "./Step3-shade.vue?vue&type=script&lang=js&"
export * from "./Step3-shade.vue?vue&type=script&lang=js&"
import style0 from "./Step3-shade.vue?vue&type=style&index=0&id=fbc36c16&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc36c16",
  null
  
)

export default component.exports